module.exports = __webpack_public_path__ + "static/media/pla_gua_pto.2ba651ca.png";